var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0624 5.91826C19.7091 3.89963 17.7208 2.39034 15.4126 1.62959C13.1043 0.868849 10.6081 0.900171 8.31969 1.71859C6.03125 2.53702 4.08144 4.09572 2.7793 6.14767C1.47716 8.19961 0.897177 10.6274 1.13127 13.0463M22.827 10.6119C23.1442 13.0767 22.6107 15.576 21.3146 17.6965C20.0184 19.817 18.0374 21.4317 15.6989 22.2736C13.3604 23.1155 10.8046 23.1342 8.45411 22.3266C6.10357 21.519 4.09907 19.9335 2.77203 17.8322",
    stroke: "#7057F0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8515 3.5235L21.5472 6.41796L18.6525 6.11374M5.34247 17.8839L2.44771 17.5797L2.14346 20.4741",
    stroke: "#7057F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstArrowIcon);
export default __webpack_public_path__ + "static/media/FirstArrowIcon.6ea16fb79894facf4b0b8fc66faabb34.svg";
export { ForwardRef as ReactComponent };